import kaplay from "kaplay";

export const k = kaplay({
  width: 1080,
  height: 1080,
  letterbox: true,
  debug: false,
  background: "#130208",
  font: "pixel",
})